<mat-toolbar class="container-fluid" [ngClass]="footerHomeClass">
    <div class="links">
        <span>v.{{version}}</span>
        <span class="divider"></span>
        <button mat-button>Terms & Conditions</button>
        @if (privacyPolicyLink) {
          <span class="divider"></span>
          <a mat-button [href]="privacyPolicyLink" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        }
        @if (cookiePolicyLink) {
          <span class="divider"></span>
          <a mat-button [href]="cookiePolicyLink" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
        }
    </div>
    <div>© 2020 Butterfly. All rights reserved.</div>
    <div class="logo-container">
      <span>powered by</span>
      <img class="logo" src="assets/img/butterfly-logo.png"/>
    </div>
</mat-toolbar>


